export default __webpack_public_path__ + "static/media/basic-family-pizza.f76133b5.png";